import { Component } from "@angular/core";
import { SettingsMenuService } from "../../services/settings-menu/settings-menu.service";
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { BackdropService } from 'src/app/services/backdrop/backdrop.service';

@Component({
    selector: 'xqnr-settings-menu-btn',
    templateUrl: './settings-menu-btn.component.pug',
    styleUrls: ['./settings-menu-btn.component.scss'],
    standalone: false
})
export class SettingsMenuBtnComponent {
  icons = {
    faQuestionCircle
  };

  constructor(
    private settingsMenu: SettingsMenuService,
    private backdrop: BackdropService
  ) {}

  open() {
    this.settingsMenu.show();
    this.backdrop.show();
  }
}
